module.exports = __webpack_public_path__ + "media/img/why-vendor/01-42a5548863a7a6fcb21974ad6c2f52e1.png";